import { render, staticRenderFns } from "./MicroserviceResource.vue?vue&type=template&id=481f4a7b&"
import script from "./MicroserviceResource.vue?vue&type=script&lang=js&"
export * from "./MicroserviceResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports